import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { defineFirestoreCollection } from "./firebaseCollectionSchema.mjs";
import { PiiCategory, meta } from "./meta.mjs";
import { z as z$1 } from "zod";

// src/models/product.ts
const firestoreStripeProductSchema = z$1.object({
	id: zodFlavorId(),
	stripeProductId: zodFlavorId(),
	name: z$1.string(),
	description: z$1.string(),
	price: z$1.object({
		amount: z$1.number(),
		currency: z$1.string(),
		defaultPriceId: zodFlavorId()
	}),
	consultation: z$1.boolean(),
	/** Stripe Product.metadata mirror — clinical consults use `consultType`. */
	metadata: meta(z$1.record(z$1.string(), z$1.string()).optional(), {
		bqType: "stringified_map",
		pii: { category: "freeText" }
	}),
	active: z$1.boolean(),
	createdAt: z$1.any().transform(zodTransformFirestoreTimestampToDate),
	updatedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate),
	lastSyncedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate)
});
/** Metadata key on Stripe Product / Firestore products for clinical consult pricing. */
const STRIPE_PRODUCT_METADATA_CONSULT_TYPE = "consultType";
/** Metadata key for insured copay and no-show fee catalog products. */
const STRIPE_PRODUCT_METADATA_CONSULT_CHARGE_KIND = "consultChargeKind";
/** Metadata key for customer-facing plan pickers (site catalog). Stripe stores this as a string. */
const STRIPE_PRODUCT_METADATA_AVAILABLE_ON_SITE = "availableOnSite";
function isProductAvailableOnSite(product) {
	return product.metadata?.[STRIPE_PRODUCT_METADATA_AVAILABLE_ON_SITE] === "true";
}
/**
* Stripe products collection definition
* Path: products/{productId}
*/
const StripeProducts = defineFirestoreCollection("products", firestoreStripeProductSchema, void 0, {
	dwReplication: true,
	firestoreCollectionPath: "products"
});

export { STRIPE_PRODUCT_METADATA_AVAILABLE_ON_SITE, STRIPE_PRODUCT_METADATA_CONSULT_CHARGE_KIND, STRIPE_PRODUCT_METADATA_CONSULT_TYPE, StripeProducts, firestoreStripeProductSchema, isProductAvailableOnSite };
//# sourceMappingURL=product.mjs.map